package com.neurobs.react.semanticui

import com.neurobs.react.{ReactUtil, StyleUtil}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks.useEffect
import slinky.core.facade.ReactElement
import slinky.web.html._

import scala.scalajs.js


object UiDropdownFactory {

  private def TemplateDropdown[T](dropdownModifiers: String)(
    placeholder: String,
    selections: Seq[T],
    itemGenerator: T => Seq[ReactElement],
    selected: Option[T],
    displayGenerator: T => String,
    classString: String = "") = {

    @react
    object DropdownElement {
      case class Props()

      val component = FunctionalComponent[Props] { props =>

        useEffect(() => {
          js.Dynamic.global.initializeDropdown()
        }, Vector())

        def selectedStyle = StyleUtil.makeStyle(
          ("overflow", "hidden"),
          ("textOverflow", "ellipsis"),
          ("wordWrap", "break-word"),
          ("display", "block"),
        )

        div(
          className := s"ui fluid $dropdownModifiers dropdown ${classString}",
        )(
          input(`type` := "hidden", name := placeholder),
          i(className := "dropdown icon"),
          div(
            className := s"default text ${if (selected.isDefined) "black-text" else ""}",
            style := selectedStyle
          )(
            selected match {
              case None => placeholder
              case Some(selection) => displayGenerator(selection)
            }
          ),
          div(className := "menu")(
            selections.flatMap(selection => itemGenerator(selection))
          )
        )
      }
    }

    DropdownElement()
  }

  private def TemplateDropdownItem(handleClick: () => Unit, keyString: String, classString: String)(children: ReactElement*) = {

    div(
      className := s"item $classString",
      onClick := handleClick,
      onSelect := {() => {}},
      key := keyString
    )(
      children:_*
    )
  }

  def SearchSelectionDropdown[T](placeholder: String, selections: Seq[T],itemGenerator: T => Seq[ReactElement], selected: Option[T], displayGenerator: T => String,  classString: String = "") = {
    TemplateDropdown("search selection")(placeholder, selections, itemGenerator, selected, displayGenerator, classString)

  }

  def SelectionDropdown[T](placeholder: String, selections: Seq[T], itemGenerator: T => Seq[ReactElement], selected: Option[T], displayGenerator: T => String, classString: String = "") = {
    TemplateDropdown("selection")(placeholder, selections, itemGenerator, selected, displayGenerator, classString)
  }

  def LabeledIconSelectionDropdown[T](placeholder: String, selections: Seq[T], itemGenerator: T => Seq[ReactElement], selected: Option[T], displayGenerator: T => String, classString: String = "") = {
    TemplateDropdown("selection labeled icon")(placeholder, selections, itemGenerator, selected, displayGenerator)
  }

  def LoadingDropdown(loadingMessage: String, classString: String = "") = {
    TemplateDropdown[String]("loading selection")(loadingMessage, Seq(), _ => Seq(div()), None, _ => "", classString)
  }

  def DisabledDropdown(placeholder: String, classString: String = "") = {
    TemplateDropdown[String]("selection disabled")(placeholder, Seq(), _ => Seq(div()), None, _ => "", classString)
  }

  def DropdownItem(handleClick: () => Unit, keyString: String, classString: String = "")(children: ReactElement*) = {
    TemplateDropdownItem(handleClick, keyString, classString)(children:_*)
  }

  def DropdownText(text: String, classString: String = "", styleAttributes: Seq[(String, js.Any)] = Seq()) = {
    span(className := s"dropdown-text $classString", style := StyleUtil.makeStyle(styleAttributes:_*))(text)
  }

  def DropdownSubtext(text: String, classString: String = "", styleAttributes: Seq[(String, js.Any)] = Seq()) = {
    span(className := s"dropdown-subtext $classString", style := StyleUtil.makeStyle(styleAttributes:_*))(text)
  }
}






